import { supabase } from "@/integrations/supabase/client";

export async function writeAuditLog(params: {
  action: string;
  entity_type: string;
  entity_id?: string;
  before_value?: unknown;
  after_value?: unknown;
  reason?: string;
  group_id?: string;
}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;
  
  await supabase.rpc("write_audit_log" as any, {
    _action: params.action,
    _entity_type: params.entity_type,
    _entity_id: params.entity_id ?? null,
    _before_value: params.before_value ? JSON.stringify(params.before_value) : null,
    _after_value: params.after_value ? JSON.stringify(params.after_value) : null,
    _reason: params.reason ?? null,
    _group_id: params.group_id ?? null,
  });
}

export async function isAdmin(): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return false;
  const { data } = await supabase
    .from("user_roles")
    .select("role")
    .eq("user_id", user.id)
    .eq("role", "app_admin")
    .maybeSingle();
  return !!data;
}

export function exportToCSV(data: Record<string, unknown>[], filename: string) {
  if (!data.length) return;
  const headers = Object.keys(data[0]);
  const csv = [
    headers.join(","),
    ...data.map(row =>
      headers.map(h => {
        const val = row[h];
        const str = typeof val === "object" ? JSON.stringify(val) : String(val ?? "");
        return `"${str.replace(/"/g, '""')}"`;
      }).join(",")
    ),
  ].join("\n");
  downloadBlob(csv, `${filename}.csv`, "text/csv");
}

export function exportToJSON(data: unknown[], filename: string) {
  downloadBlob(JSON.stringify(data, null, 2), `${filename}.json`, "application/json");
}

function downloadBlob(content: string, filename: string, type: string) {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function createOutboxEvent(params: {
  event_type: string;
  payload?: Record<string, unknown>;
  group_id?: string;
}) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  await supabase.from("integration_outbox").insert({
    event_type: params.event_type,
    payload: (params.payload ?? {}) as any,
    group_id: params.group_id ?? null,
    created_by: user.id,
  } as any);
}
